import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function RadioAdModal({ onClose }) {
  const navigate = useNavigate();
  const backdropRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Smooth entrance
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // Smooth close
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 450);
  };

  return (
    <div
      ref={backdropRef}
      onClick={(e) => {
        if (e.target === backdropRef.current) handleClose();
      }}
      className="fixed inset-0 flex items-center justify-center z-[110] p-4 md:p-8 font-libre"
      style={{
        backgroundColor: isVisible ? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0)',
        backdropFilter: isVisible ? 'blur(8px)' : 'blur(0px)',
        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <div
        className="relative w-full max-w-[95%] md:max-w-4xl bg-black rounded-lg overflow-hidden shadow-[0_50px_100px_-20px_rgba(0,0,0,0.8)] border border-white/10"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1) translateY(0)' : 'scale(0.98) translateY(20px)',
          transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        {/* FULL IMAGE DISPLAY */}
        <div className="relative w-full h-auto flex items-center justify-center overflow-hidden">
          <img
            src="/assets/radio.jpeg"
            alt="Radio Broadcast"
            className="w-full h-auto max-h-[85vh] object-contain block shadow-2xl"
          />
          
          {/* BOTTOM RIGHT OVERLAY ACTIONS - CLEAN DESIGN */}
          <div className="absolute bottom-4 right-4 md:bottom-8 md:right-8 flex items-center gap-2 md:gap-4 z-50">
            <button
              onClick={handleClose}
              className="px-3 md:px-6 py-2 md:py-3.5 text-[9px] md:text-xs font-bold uppercase tracking-widest text-white/50 hover:text-white bg-black/40 hover:bg-black/60 backdrop-blur-xl rounded-md border border-white/10 transition-all"
            >
              Close
            </button>
            
            <button
              onClick={() => {
                navigate('/radio');
                handleClose();
              }}
              className="px-4 md:px-8 py-2 md:py-3.5 bg-white text-black text-[9px] md:text-xs font-bold uppercase tracking-widest rounded-md shadow-xl hover:bg-gray-100 hover:-translate-y-0.5 transition-all flex items-center gap-2 md:gap-3 group"
            >
              <span>Launch Studio</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-3 h-3 md:w-3.5 md:h-3.5 group-hover:translate-x-1 transition-transform">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
